// extracted by mini-css-extract-plugin
export default {"container":"ModalDomicilio_container__jO4eW","title":"ModalDomicilio_title__zy6ld"};